import styled from "@emotion/styled";
import { css, Global } from "@emotion/react";

const globalStyles = css`
  .MuiAccordionSummary-root {
    min-height: 45px !important;
  }
  .MuiAccordionSummary-content {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .MuiAccordionDetails-root {
    padding: 0px !important;
  }
`;
const Container = styled.div((props) => ({
  marginBottom: props.marginBottom ? props.marginBottom : "15px",
}));

const SC = {
  Container,
  GlobalStyles: <Global styles={globalStyles} />,
};

export default SC;
